// Catalogue seed Pizz'n Co (D3, tech-design §3.3).
// Clé naturelle = `nom` (unique dans la carte). AUCUN id primaire codé en dur
// (la PK `++id` est globale : des ids fixes casseraient le cloisonnement si un 2e
// tenant apparaissait sur le device).
// Source : https://pizznco.fr/pizzas-du-soir/ (extraite le 10/07). Prix à
// re-confirmer par Coralie — si écart : éditer + bump SEED_VERSION à 3.
// « Romaine » et « 4 Fromages » existent en 2 bases -> suffixées (nom unique).
// « Pizza sur mesure » : composition via modificateurs/notes D6 ; le supplément
// éventuel vit dans la note libre — JAMAIS de champ prix ajouté (INV-D).

export const SEED_VERSION = 2;

export interface CatalogueEntry {
  nom: string;
  prix_indicatif: number;
  description?: string;
  actif: boolean;
}

export const CATALOGUE: readonly CatalogueEntry[] = [
  // --- Base tomate (13) ---
  { nom: 'Margarita', prix_indicatif: 9, description: 'mozzarella, origan', actif: true },
  { nom: 'Romaine (tomate)', prix_indicatif: 10, description: 'jambon, origan', actif: true },
  { nom: 'Napolitaine', prix_indicatif: 11, description: 'anchois, câpres, origan', actif: true },
  { nom: 'Chorizo', prix_indicatif: 11, description: 'chorizo, origan', actif: true },
  { nom: 'Cyclope', prix_indicatif: 11, description: 'jambon, œuf, crème, origan', actif: true },
  { nom: '4 Fromages (tomate)', prix_indicatif: 12, description: 'reblochon, chèvre, bleu, mozzarella, origan', actif: true },
  { nom: 'Chamarelle', prix_indicatif: 12, description: "cœurs d'artichaut, tomates cerises, mozzarella, pesto", actif: true },
  { nom: 'Végétarienne', prix_indicatif: 12, description: 'courgettes, aubergines grillées, tomates-cerises, parmesan, pesto', actif: true },
  { nom: 'Forestière', prix_indicatif: 12, description: 'poulet, champignons, œuf, crème, origan', actif: true },
  { nom: 'Mexicaine', prix_indicatif: 12, description: 'viande hachée, poivrons, crème, épices mexicaines', actif: true },
  { nom: 'Orientale', prix_indicatif: 12, description: 'merguez, poivrons, crème, épices orientales', actif: true },
  { nom: 'Carnivore', prix_indicatif: 13, description: 'poulet, merguez, bœuf, crème, sauce burger', actif: true },
  { nom: 'Burger', prix_indicatif: 13, description: 'viande hachée, oignons rouges, pickles, tomates-cerises, cheddar, sauce burger', actif: true },

  // --- Base crème (11) ---
  { nom: 'Romaine (crème)', prix_indicatif: 11, description: 'jambon, origan', actif: true },
  { nom: '4 Fromages (crème)', prix_indicatif: 12, description: 'reblochon, chèvre, bleu, mozzarella, origan', actif: true },
  { nom: 'Cendrée', prix_indicatif: 12, description: 'jambon, noix, gorgonzola', actif: true },
  { nom: 'Dulce', prix_indicatif: 12, description: 'chèvre, miel, sésame', actif: true },
  { nom: 'Indienne', prix_indicatif: 12, description: 'poulet, poivrons, sauce curry', actif: true },
  { nom: 'Savoyarde', prix_indicatif: 12, description: 'oignons rouges, lardons, reblochon AOP', actif: true },
  { nom: 'Paysanne', prix_indicatif: 12, description: 'pommes de terre, lardons, tome de Savoie', actif: true },
  { nom: 'Normande', prix_indicatif: 12, description: 'pommes de terre, jambon, camembert', actif: true },
  { nom: 'Ravioles', prix_indicatif: 13, description: 'ravioles de Saint-Jean, jambon', actif: true },
  { nom: 'Baltique', prix_indicatif: 13, description: 'saumon fumé, aneth', actif: true },
  { nom: 'Douceur Estivale', prix_indicatif: 12, description: 'feta émiettée, menthe ciselée, éclats de pistache, tomates séchées', actif: true },

  // --- Calzones (2) ---
  { nom: 'Trady', prix_indicatif: 12, description: 'base tomate, jambon, champignons, œuf, crème, origan', actif: true },
  { nom: 'Bleue', prix_indicatif: 12, description: 'base tomate, bleu, jambon, œuf, crème, origan', actif: true },

  // --- Spéciales (3) ---
  { nom: 'Pizza nutella', prix_indicatif: 8, description: 'Nutella, topping au choix', actif: true },
  { nom: 'Menu des gones', prix_indicatif: 9, description: 'petite pizza au choix + surprise', actif: true },
  { nom: 'Pizza sur mesure', prix_indicatif: 13, description: 'base au choix + 4 ingrédients', actif: true },
] as const;
